// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangePassword_content__zNp4u"};